import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Translation } from '@/hoslog-intl';

export const Route = createFileRoute('/(app)/points-management/system-transfer')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <Translation id="pointManagement.sidebar.menu.systemTransfer" />,
      title: <Translation id="pointManagement.sidebar.menu.systemTransfer" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
